export default {
  validate(res) {
    if (res.code === '000000') {
      return true
    }
    return false
  }
}
